
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ApiService from "@/core/services/ApiService";

interface NewTaskData {
  privacy_policy: boolean;
  pricing_recurring: boolean;
  website_content: boolean;
  products_sold: boolean;
  merchant_account: boolean;
  payment_processor: boolean;
  terms_conditions: boolean;
  task_group: boolean;
}

export default defineComponent({
  name: "add-task-modal",
  emit: ["submit"],

  components: {},
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const addTaskModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const existing_group = ref<boolean>(false);
    const customer_group = ref<boolean>(false);

    const targetData = ref<NewTaskData>({
      privacy_policy: false,
      pricing_recurring: false,
      website_content: false,
      products_sold: false,
      merchant_account: false,
      payment_processor: false,
      terms_conditions: false,
      task_group: false,
    });

    const submitButtonRef = ref<HTMLButtonElement | null>(null);
    const merchants = ref([]);
    const categories = ref([]);
    console.log(merchants);

    const store = useStore();
    onMounted(() => {
      setTimeout(async () => {
        const resp = await ApiService.get(
          `merchants/accounts?limit=200&group_id=IN${store.getters.currentUser.data.group_owners}`
        );
        merchants.value = resp.data.data;

      }, 1000);
    });
    const submit = async () => {
      if (!formRef.value) {
        return;
      }

      submitButtonRef.value!.disabled = true;
      // Activate indicator
      submitButtonRef.value?.setAttribute("data-kt-indicator", "on");

      const payload: any = { ...targetData.value };

      try {
        const res = await ApiService.post(
          `merchants/tasks?action=new_task`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "New Task Successfully Created!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            emit("submit");
            hideModal(addTaskModalRef.value);
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ooops, something went wrong!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Ooops!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Ooops, something went wrong!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      submitButtonRef.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButtonRef.value!.disabled = false;

      /* formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      }); */
    };

    return {
      targetData,
      submit,
      loading,
      formRef,
      addTaskModalRef,
      submitButtonRef,
      merchants,
      categories,
      existing_group,
      customer_group,
    };
  },
});
